module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921074151_T.0aedbe6e.jpg";